export const dashboardTiles = [
  {
    id: '1',
    title: 'BRACE Website',
    url: 'https://cos.brsd.ab.ca',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/1tmv72ch_Copy%20of%20BRACE%20Logo%20%281%29.png'
  },
  {
    id: '2',
    title: 'Calendar',
    url: 'https://cos.brsd.ab.ca/about/calendar',
    iconName: 'Calendar'
  },
  {
    id: '3',
    title: 'Newsletter',
    url: 'http://cos.brsd.ab.ca/about/newsletters',
    iconName: 'Newspaper'
  },
  {
    id: '4',
    title: 'Fees and Forms - Rycor',
    url: 'https://www.brsd.ab.ca/families/online-payments-ordering',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/2bz6jrim_online%20form.png'
  },
  {
    id: '5',
    title: 'Registration Forms',
    url: 'https://brsd.schoolengage.ca/#/login',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/6l25uc75_school%20engage.png'
  },
  {
    id: '6',
    title: 'Gmail',
    url: 'http://gmail.brsd.ab.ca/',
    iconName: 'Mail'
  },
  {
    id: '7',
    title: 'PowerSchool',
    url: 'https://brsd.powerschool.com/public/home.html',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/93bdgsad_PowerSchool.jpg'
  },
  {
    id: '8',
    title: 'Moodle',
    url: 'https://moodle.brsd.ab.ca/login/index.php',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/zwgouht1_moodle.png'
  },
  {
    id: '9',
    title: 'Handbook',
    url: 'https://cos.brsd.ab.ca/download/531418',
    iconName: 'BookOpen'
  },
  {
    id: '10',
    title: 'Bell Schedule',
    url: 'https://cos.brsd.ab.ca/about/bell-schedule',
    iconName: 'Bell'
  },
  {
    id: '11',
    title: 'Staff Directory',
    url: 'https://cos.brsd.ab.ca/about/staff-directory',
    iconName: 'Users'
  },
  {
    id: '12',
    title: 'High School+',
    url: 'https://sites.google.com/brsd.ab.ca/brsdcareer/home',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/5yl77ldc_high%20school%20plus.png'
  },
  {
    id: '13',
    title: 'Career Counselling Newsletter',
    url: 'https://www.instagram.com/hsplusbrsd/',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/rvasgfuk_Career%20Counselling%20newsletter.jpg'
  },
  {
    id: '14',
    title: 'myPass',
    url: 'https://public.education.alberta.ca/PASI/myPass/welcome',
    customIcon: 'https://customer-assets.emergentagent.com/job_link-hub-18/artifacts/jpdwrcef_mypass.png'
  },
  {
    id: '15',
    title: 'Instagram',
    url: 'https://www.instagram.com/braceschool_brsd/'
  },
  {
    id: '16',
    title: 'Facebook',
    url: 'https://www.facebook.com/Braceschool/'
  }
];